module.exports = __webpack_public_path__ + "f98bf4d8870f6d6d13a841a34ea522ba.svg";